var React = require('react');

function Y3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Y3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"38.97 29.48 24.64 2.27 0 0 24.28 46.09 38.97 29.48","fill":"#73c9bd"})),React.createElement("polygon",{"points":"70.07 4.89 45.34 4.33 7.83 83.53 32.56 84.09 70.07 4.89","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Y3.defaultProps = {"viewBox":"0 0 70.07 84.09"};

module.exports = Y3;

Y3.default = Y3;
